import { z } from 'zod';
import { requiredString } from '../helpers';
export const Amazon_Connect_Transfer_To_Flow_1_ConfigValidator = z
    .object({
    instanceId: requiredString('Amazon Connect Connection is required'),
    contactFlowId: requiredString('Contact Flow is required'),
    contactId: z.string().optional(),
    phoneNumber: z.string().optional(),
    attributes: z.record(z.string(), z.string()).optional()
})
    .refine((data) => data.contactId || data.phoneNumber, {
    path: ['lookupMethod'],
    error: 'Either phone number or Contact ID must be provided'
});
//# sourceMappingURL=amazon-connect-transfer-to-flow-1.js.map